var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 13.4375V5.125H9.625V2.0625H4.8125V7.75H3.5V2.0625V0.75H4.8125H10.5L14 4.25V13.4375V14.75H12.6875H4.8125H3.5V13.4375V10.8125H4.8125V13.4375H12.6875ZM8.12109 6.62891L10.3086 8.81641L10.7734 9.28125L10.3086 9.74609L8.12109 11.9336L7.65625 12.3984L6.72656 11.4688L7.19141 11.0039L8.25781 9.9375H0.65625H0V8.625H0.65625H8.25781L7.19141 7.55859L6.72656 7.09375L7.65625 6.16406L8.12109 6.62891Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentArrowRight);
export default __webpack_public_path__ + "static/media/document-arrow-right.ce81cc24544a40ed9f66d35cb763d048.svg";
export { ForwardRef as ReactComponent };